<script lang="js" setup></script>

<template>
  <div class="h-[358px] bg-pageTertiary">
    <div class="w-[1200px] h-full mx-auto flex items-center relative">
      <h1 class="font-bold text-5xl text-textPrimary leading-[72px]">
        <p>{{ $t('邀请好友注册') }}</p>
        <i18n-t keypath="轻松获得 {0}" scope="global" tag="p">
          <span class="text-openLongBtnHover">{{ $t('交易返佣') }}</span>
        </i18n-t>
      </h1>
      <img src="@/assets/images/referral/banner.png" class="w-[454px] h-[358px] absolute end-0 top-0">
    </div>
  </div>
</template>
